import React, { Component } from 'react';
import { faShoppingCart, faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import services from '../../services/index';
import GLOBAL from "../../global"

import { connect } from "react-redux";
import { bindActionCreators } from "redux"
import * as Actions from "../../store/actions"
import ButtonMaterial from '@material-ui/core/Button';
import styles from './style.module.css'
import { withRouter } from "react-router-dom";
import { isEmpty, isArray } from "lodash"
import { AiOutlineShoppingCart } from "react-icons/ai";
import {
  ContainerAdressChoice,
  CustomModal
} from "./style"


import './ItensPedido.css'


class InfoPedidos extends Component {


  constructor(props) {
    super(props);

    let entregaAgendada = false;
    let retiradaAgendada = false;

    const loja = services.getLastStore() || {};



    if (!isEmpty(loja)) {
      if (isArray(loja)) {
        entregaAgendada = loja[0].entrega_agendada === 'S'
        retiradaAgendada = loja[0].retirada_agendada === 'S'
      }
      this.props.setStores(loja)
    }

    this.state = {
      total: 0,
      subtotal: 0,
      teste: [],
      goPagamento: false,
      additionalClass: this.props.additionalClass || '',
      loja: loja,
      goEditarItens: false,
      taxa: 0,
      showAdressChoice: false,
      cep: '',
      entregaComAgenda: entregaAgendada,
      retiradaComAgenda: retiradaAgendada,
      loading: false
    }
  }



  componentDidMount() {

    this.setState({ taxa: this.props.taxa || 0 })
  }



  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      let response = services.totalizaItens(this.props.rdOrder.itens, this.props.taxa, '', true, false, this.state.taxa);
      this.setState({ total: response.data.total, subtotal: response.data.subtotal, taxa: prevProps.taxa });
    }
  }



  findStoreByCep = async () => {
    try {

      this.setState({ loading: true });

      let auxStores = [];

      if (!isArray(this.props.rdStores.stores)) {
        auxStores.push(this.props.rdStores.stores);
      } else {
        auxStores = this.props.rdStores.stores;
      }

      const adress = await services.returnNextStore(auxStores, this.state.cep);

      if (adress.length === 0) {
        return alert('Desculpe, mas essa loja não atende ao cep informado.')
      }

      const enderecoInfo = await services.consultaCep(this.state.cep);
      this.setState({ loading: false });
      this.props.history.push('CadastroCliente/' + JSON.stringify(enderecoInfo));
    } catch (error) {
      this.setState({ loading: false });
      alert('Ops... Algo deu errado');
    }
  }



  handleCep = (e) => {
    const word = e.target.value.replace(/\D/g, '');
    this.setState({ cep: word });
  }


  goPag = async () => {


    if (this.state.loja[0].val_min_pedido > this.state.total) {
      return alert("O valor total de sua compra é menor que o valor mínimo para o pedido")
    }

    const isLogado = services.getLogado();

    if (isLogado) {
      this.props.setDataEndOrder({
        dados_loja: this.state.loja, logado: true,
        itens: this.props.rdOrder.itens,
        subtotal: this.state.subtotal,
        taxa: this.state.taxa,
        total: this.state.total,
        funcVerificaLoja: this.props.funcVerificaLoja,
      });
      this.props.history.push('FinalizaPagamento')
    } else {

      this.setState({ showAdressChoice: true })
    }
  }



  handleRetira = () => {
    this.props.history.push('CadastroCliente/{}');
  }



  goEditaPedido = () => {
    this.props.history.push('LancaPedido')
  }


  editItem(item, index) {
    debugger
    if (this.props.openItem) {
      this.props.openItem(item, index);
    }
  }

  render() {

    return (
      <>
        <div className={`box-pedido semBordas ${this.state.additionalClass}`}>
          <div className="title-pedido">
            <AiOutlineShoppingCart size={23} />
            <p id="titleCarrinho">Carrinho de compras</p>
          </div>

          <div className="content-itens">

            {
              this.props.rdOrder.itens.map((item, index) => {

                return (
                  <div key={index}>
                    <div className="row iteminbox" onClick={this.editItem.bind(this, item, index)}>
                      <div className="col-md-7 col-sm-7 col-xs-7">
                        <p className="descItemPedido"><FontAwesomeIcon icon={faPencilAlt} className="pancil" />{`${item.quantidade} x ${item.produto}`}</p>
                      </div>
                      <div className="col-md-5 col-sm-5 col-xs-5">

                        <p id="priceItem">R$ {item.total.toFixed(2)}</p>
                      </div>
                    </div>



                    {
                      item.partes.massa ? (
                        item.partes.massa.descricao ? (
                          <div className="row iteminbox">
                            <div className="col-md-12">
                              <p className="obsPedido">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>Massa -></strong> {`${item.partes.massa.descricao} `} {item.partes.massa.preco ? `( R$ ${item.partes.massa.preco.toFixed(2)} )` : ""}</p>
                            </div>

                          </div>
                        ) : ''
                      ) : ''
                    }




                    {
                      item.partes.borda ? (
                        item.partes.borda.descricao ? (
                          <div className="row iteminbox">
                            <div className="col-md-12">
                              <p className="obsPedido">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>Borda -></strong> {`${item.partes.borda.descricao} `}  {item.partes.borda.preco ? `( R$ ${item.partes.borda.preco.toFixed(2)} )` : ""}</p>
                            </div>

                          </div>
                        ) : ''

                      ) : ''
                    }





                    {
                      item.partes ? (
                        item.partes.produtos.map((parte, index) => {
                          return (
                            <div className="row iteminbox" key={index}>
                              <div className="col-md-12">
                                <p className="obsPedido">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`${parte.produto} `} {parte.produto.PRECO ? `( R$ ${parte.produto.PRECO.toFixed(2)} )` : ""}</p>
                              </div>

                            </div>
                          )
                        })

                      ) : ''
                    }

                    {
                      item.partes ? (
                        item.partes.toppings.map((topping, index) => {
                          debugger
                          return (
                            <div className="row iteminbox" key={index}>
                              <div className="col-md-12">
                                <p className="obsPedido">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`++${topping.produto} `} {topping.PRECO ? `( R$ ${topping.PRECO.toFixed(2)} )` : ""}</p>
                              </div>

                            </div>
                          )
                        })

                      ) : ''
                    }

                    {
                      item.partes.partesCombo ? (
                        item.partes.partesCombo.map((produto, index) => {
                          return (
                            <div className="row iteminbox" key={index}>
                              <div className="col-md-12">
                                <p className="obsPedido">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`${produto.produto} `}</p>
                              </div>

                            </div>
                          )
                        })

                      ) : ''
                    }

                    {
                      item.partes.prodGratis ? (
                        item.partes.prodGratis.produto ? (
                          <div className="row iteminbox">
                            <div className="col-md-12">
                              <p className="obsPedido">&nbsp;&nbsp;&nbsp;&nbsp;<strong>Promo -></strong> {`${item.partes.prodGratis.produto} `}</p>
                            </div>

                          </div>
                        ) : ''

                      ) : ''
                    }





                    {
                      item.obs ? (
                        <div className="row iteminbox">
                          <div className="col-md-12">
                            <p className="obsPedido">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`--${item.obs} `}</p>
                          </div>

                        </div>
                      ) : ''
                    }
                  </div>



                );
              })
            }
          </div>

          <div className="footer-pedido">



            {this.props.isPag && <div className="lineTotais">
              <span className="desc-title left" style={{ fontWeight: 'normal', fontSize: 12 }}>
                Taxa de entrega
              </span>
              <span className="desc-value right" style={{ fontWeight: 'normal', fontSize: 12 }}>
                R$ {Number(this.state.taxa).toFixed(2) || '0.00'}
              </span>
            </div>}




            <div className="lineTotais">
              <span className="desc-title left">
                Total do pedido
              </span>
              <span className="desc-value right" style={{ fontWeight: 'bold' }}>
                R$ {(this.state.total.toFixed(2))}
              </span>
            </div>

            {
              this.state.total > 0 && this.props.showPag ? (<button
                onClick={this.goPag}
                type="button"
                className="btn btn-primary btn-lg btn-block btn-pagar"
                style={{ background: GLOBAL.COLORS.primary }}
              >
                Finalizar Pedido
              </button>) : ''

            }

            {
              !this.props.showPag ? (<button
                onClick={this.goEditaPedido}
                type="button"
                className="btn btn-primary btn-lg btn-block btn-pagar"
                style={{ background: GLOBAL.COLORS.primary }}
              >
                Editar Pedido
              </button>) : ''
            }

          </div>
        </div>


        <CustomModal show={this.state.showAdressChoice} onHide={() => this.setState({ showAdressChoice: false })}>
          <ContainerAdressChoice>
            <h2>Por favor, nos informe seu CEP</h2>
            <p>Dessa forma, conseguiremos verificar se entregamos no seu endereço</p>
            <input
              value={this.state.cep}
              class="inputcepitnes"
              placeholder="00000000"
              maxLength="8" pattern="[0-9]*"
              onChange={this.handleCep}
            />
            <ButtonMaterial class="buttonSearchCep" onClick={this.findStoreByCep}>
              {this.state.loading ? 'Aguarde...' : 'VERIFICAR CEP'}
            </ButtonMaterial>

            <p id="ouCep">Ou</p>

            <ButtonMaterial class="buttonRetire" onClick={this.handleRetira}>Retire na loja</ButtonMaterial>

            {
              this.state.entregaComAgenda && (
                <>
                  <p id="ouCep">Ou se preferir</p>
                  <ButtonMaterial class="buttonRetire pastel" onClick={this.handleRetira}>Agende uma entrega</ButtonMaterial>
                </>
              )

            }

          </ContainerAdressChoice>
        </CustomModal>
      </>
    );
  }
}


const mapStateToProps = state => ({
  rdUser: state.user,
  rdOrder: state.order,
  rdStores: state.stores
})

const mapDispathToPros = dispatch => bindActionCreators(Actions, dispatch)

export default withRouter(connect(mapStateToProps, mapDispathToPros)(InfoPedidos))



